import '../../styles/global.css';

import { withTransaction } from '@elastic/apm-rum-react';
import { ThemeProvider } from '@mui/material';
import { themeLight } from '@resurs-internal/mui';
import { ReactNode, useCallback, useMemo, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import createTranslateService from '../../api/translation';
import ApplicationStyleWrapper from '../../components/ApplicationStyleWrapper/ApplicationStyleWrapper';
import DemoHeader from '../../components/DemoHeader/DemoHeader';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import SessionDialog from '../../components/SessionDialog/SessionDialog';
import { appConfig } from '../../config';
import { BannerTypeContext } from '../../context/BannerTypeContext';
import { RightPanelContext } from '../../context/RightPanelContext';
import { TranslationProvider } from '../../context/TranslationContext';
import { ConsumerLoanTargetPath } from '../../domain/types';
import { getPath } from '../../helpers/url';
import useSettings from '../../hooks/useSettings';
import { Root } from './RootPage.styles';

const RootPage = () => {
    const { languageCode } = useSettings();
    const navigate = useNavigate();
    const settings = useSettings();
    const translate = useMemo(() => createTranslateService(languageCode), [languageCode]);
    const [bannerType, setBannerType] = useState<string>('');
    const [rightPanelContent, setRightPanelContent] = useState<ReactNode>(null);

    const onLogout = useCallback(() => {
        navigate(getPath(ConsumerLoanTargetPath.logout, settings.languageCode, settings.countryCode));
    }, [navigate, settings.languageCode, settings.countryCode]);

    return (
        <Root>
            <TranslationProvider translate={translate}>
                <ThemeProvider theme={themeLight}>
                    <SessionDialog
                        maxIdleTime={appConfig.maxIdleTime}
                        logoutWarnTime={appConfig.logoutWarnTime}
                        onLogout={onLogout}
                    />
                    <ErrorBoundary>
                        <DemoHeader />
                        <BannerTypeContext.Provider value={{ bannerType, setBannerType }}>
                            <RightPanelContext.Provider value={{ rightPanelContent, setRightPanelContent }}>
                                <ApplicationStyleWrapper>
                                    <Outlet />
                                </ApplicationStyleWrapper>
                            </RightPanelContext.Provider>
                        </BannerTypeContext.Provider>
                    </ErrorBoundary>
                </ThemeProvider>
            </TranslationProvider>
        </Root>
    );
};

export default withTransaction('Routing', 'route-change')(RootPage);
